/** @jsx jsx */
import { useDirection } from '@front10/utils';
import { jsx, Styled } from '../types';

interface Props {
  size?: number | number[];
  viewBox?: string;
  rtlFlip?: boolean;
}

export type IconProps = Styled<Props & Omit<JSX.IntrinsicElements['svg'], 'ref'>>;

export function Icon({
  size,
  viewBox = '0 0 1024 1024',
  fill = 'currentColor',
  rtlFlip = false,
  sx,
  children,
  ...props
}: IconProps) {
  const direction = useDirection();

  return (
    <svg
      width="1em"
      height="1em"
      fill={fill}
      viewBox={viewBox}
      sx={{
        fontSize: size,
        transform: rtlFlip && direction === 'rtl' ? 'scaleX(-1)' : undefined,
        ...sx
      }}
      {...props}
    >
      {children}
    </svg>
  );
}
